module.exports = __webpack_public_path__ + "static/media/game(15).78c401f5.PNG";